import React from 'react';
import PropTypes from 'prop-types';
import { CagThemeProvider } from '@hyphengroup/cag-components';
import withUserAgent from 'containers/withUserAgent';

function RaThemeProvider(props) {
  const {
    children,
    userAgent,
  } = props;
  return (
    <CagThemeProvider ssr={{
      isTablet: userAgent?.isTablet ?? false,
      isMobile: userAgent?.isMobile ?? false,
    }}
    >
      {children}
    </CagThemeProvider>
  );
}

RaThemeProvider.defaultProps = {
  children: null,
};

RaThemeProvider.propTypes = {
  children: PropTypes.node,
  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
  }),
};

export default withUserAgent(RaThemeProvider);
